export default __webpack_public_path__ + "static/media/screensharing-slash.fd8ead74.svg";